import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// helpers
import { apiHelper } from '../../helper/apiHelper';

import dynamic from 'next/dynamic';
const ConnectWallet = dynamic(() => import('../../components/connectWallet'))

export default function ConnectWalletIndex({ meta, currLocale }) {
  return (
    <ConnectWallet meta={meta} currLocale={currLocale} />
  )
}

export const getStaticProps = async ({ locale }) => {

  const pageName = 'login'
  const postData = {
    language: locale,
    pageName: pageName
  }

  const resMeta = await apiHelper(`metadata/getNftMetadata`, "POST", postData, null);
  const meta = resMeta.data.status ? resMeta.data.data : null;

  const canonical = process.env.hostBaseUrl + '/' + locale + '/nft/' + pageName;

  return {
    props: {
      meta,
      currLocale: locale,
      canonical,
      dynamicURL: '/nft/' + pageName,
      pageName: meta && meta.pageHeading && meta.pageHeading !== '' ? meta.pageHeading : (locale === 'en' ? 'Connect your wallet' : 'ربط محفظتك'),
      ...(await serverSideTranslations(locale, ['common']))
    },
    revalidate: 10, // In seconds
  }
}
